export default class Car {

    constructor(obj = null) {
        obj && Object.assign(this, obj);
    };

    setLicensePlate(license_plate){
        this.license_plate = license_plate;
    };

    getLicensePlate(){
        return this.license_plate;
    };

    setModelCar(model_car){
        this.model_car = model_car;
    };

    getModelCar(){
        return this.model_car;
    };

    setColor(car_color){
        this.car_color = car_color;
    };

    getColor(){
        return this.car_color;
    };

    setModelYear(model_year){
        this.model_year = model_year;
    };

    getModelYear(){
        return this.model_year;
    };


    setFuelType(fuel_type){
        this.fuel_type = fuel_type;
    };

    getFuelType(){
        return this.fuel_type;
    };


    toJSON() {
        let {license_plate, model_car,fuel_type,model_year, car_color } = this;
        return {license_plate, model_car,fuel_type,model_year,car_color };
    }
}



// WEBPACK FOOTER //
// ./src/modules/Models/Car.js